<app-navbar *ngIf="isLoggedin"></app-navbar>
<router-outlet></router-outlet>